import SettingConfig from '@module/config/setting';
import { cn } from '@module/lib/utils';
import { IcoLive } from '@module/svg/icons';
import type { HTMLProps } from 'react';

interface Props extends HTMLProps<HTMLDivElement> {
  isRT?: boolean; // RT 대응 - 전환 후 삭제 예정
}

function LiveBadge({ className, style, isRT }: Props) {
  return (
    <div className={cn('absolute z-[5] flex h-[16px] items-center', className)}>
      {/* RT 대응 - 전환 후 삭제 예정 */}
      {isRT ? (
        <img src={`${SettingConfig.S3_BUCKET_URL}/img/icon/live_plus.svg`} alt='live plus' width={40} height={16} />
      ) : (
        <IcoLive style={{ fontSize: 32, ...style }} />
      )}
    </div>
  );
}

export default LiveBadge;
